export default __webpack_public_path__ + "static/Wherehorsesploughtheseaforfood-577f4ac5296bbba5975762ebf80ec200.jpg";